import { render, staticRenderFns } from "./RecipientHeader.vue?vue&type=template&id=02fa8cc4"
import script from "./RecipientHeader.vue?vue&type=script&lang=js"
export * from "./RecipientHeader.vue?vue&type=script&lang=js"
import style0 from "./RecipientHeader.vue?vue&type=style&index=0&id=02fa8cc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports